<template>
  <div class="head-wrap">
    <div class="top">
      <img :src="avatar" />
    </div>
    <div class="middle">
      <div class="title1">脑波仪测评报告</div>
      <div class="title2">EEG EVALUATION REPORT</div>
    </div>
    <div class="foot">
      <div>测评时间</div>
      <div class="time">{{ reportTime | datetime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    ReportData() {
      return this.$store.state.ReportData;
    },
    avatar() {
      let url = (this.ReportData.orgLogo || {}).avatar;
      if (url) {
        return this.$g.host + url;
      } else {
        return null;
      }
    },
    reportTime() {
      return (this.ReportData.studentInfo || {}).reportTime || new Date();
    },
  },
};
</script>

<style scoped lang="scss">
.head-wrap {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .top {
    img {
      width: 80px;
      height: 80px;
    }
  }
  .middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title1 {
      color: rgb(0, 171, 117);
      font-size: 24px;
      font-weight: 600;
    }
    .title2 {
      margin-top: 5px;
      color: rgba(0, 171, 117, 0.5);
    }
  }
  .foot {
    .time {
      color: rgba(0, 171, 117, 0.5);
    }
  }
}
</style>